import { SVGProps, Ref, forwardRef } from 'react';

export const SendIosFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M.5 8C.5 4.25 2.375.5 8 .5s7.5 3.75 7.5 7.5-1.875 7.5-7.5 7.5S.5 11.75.5 8m8.198-1.313v4.977h-1.4V6.687L5.494 8.49l-.99-.99 3.494-3.494L11.492 7.5l-.99.99z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
SendIosFilledSize16Glyph.displayName = 'SendIosFilledSize16Glyph';
